import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';
import VueCookies from 'vue-cookies';
import browserDetect from "vue-browser-detect-plugin";
import "core-js/stable";
import VueGtag from "vue-gtag";
import { currUID } from './assets/constants.js';

Vue.config.productionTip = false

Vue.prototype.$store = store;

Vue.use(VueCookies);
Vue.use(browserDetect);

Vue.use(VueGtag, {
  config: { 
    id: currUID,
    params: {
      send_page_view: false
    } 
  }
});

Vue.prototype.$playSound = (path, mute) => {

  var audio = document.createElement('audio');
  audio.src = path;
  audio.muted = mute;
  audio.volume = 0.5;
  document.body.appendChild(audio);
  audio.play();

  audio.onended = function () {
    audio.remove();
  };
}

//pause all sound
Vue.prototype.$pauseSound = () => {
  var audios = document.getElementsByTagName('audio')
  Array.from(audios).forEach(aud => {
    aud.pause();
  })
}
 
//resume playback
Vue.prototype.$resumeSound = () => {
  var audios = document.getElementsByTagName('audio')
  Array.from(audios).forEach(aud => {
    aud.play();
  })
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
